<template>
    <div>
        <!--功能列-->
        <div class="btare">
            <div class="backrul">
                <a href="javascript:void(0)" @click="gotoList()"> 
                    返回查詢結果
                </a>
            </div>
        </div>
        <!--權限設定本體-->
        <b-row>
            <!--群組名稱-->
            <b-col>
                <b-form-group label="群組名稱*">
                    <b-form-input 
                        placeholder="請輸入群組名稱"
                        maxlength="16"
                        v-model=DetailData.AG_NAME>
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <!--權限設定區(依類別)-->
        <b-card
            header-class="h5 px-3 py-2"
            no-body
            class="mb-3"
            v-for="(item,index) in groupOptions" :key="index">
            <template #header>
                {{ item.PJ_NAME }}
                <b-button @click="changeClick('ALL',item,item.SubList == null)">
                    全選
                </b-button>
                <b-button @click="changeClick('CANCEL',item,item.SubList == null)">
                    取消全選
                </b-button>
            </template>
            <!--次分類-->
            <b-table-simple hover small caption-top class="mb-0" v-if="item.SubList != null">
                <template v-for="item2 in item.SubList">
                    <!--還有子項目-->
                    <template v-if="item2.SubList!= null">
                        <b-tr :key="item2.PJ_ID">
                            <b-th
                                class="text-left w-25"
                                :rowspan="item2.SubList.length +1">
                                {{ item2.PJ_NAME }}
                            </b-th>
                        </b-tr>
                        <b-tr v-for="item3 in item2.SubList" :key="item3.PJ_ID">
                            <b-th class="text-left w-25">{{ item3.PJ_NAME }}</b-th>
                            <b-td class="w-50">
                                <b-form-checkbox-group v-model="item3.GP_VERIFY_LIST">
                                    <b-form-checkbox 
                                        v-for="option in filterPermission(item3.PJ_ID)" 
                                        :value="option.value">
                                        {{ option.title }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-td>
                        </b-tr>
                    </template>
                    <!--無子項目-->
                    <template v-else>
                        <b-tr :key="item2.PJ_ID">
                            <!--標頭名稱-->
                            <b-th colspan="2" class="text-left w-50">
                                    {{ item2.PJ_NAME }}
                            </b-th>
                            <!--功能-->
                            <b-td class="w-50">
                                <b-form-checkbox-group v-model="item2.GP_VERIFY_LIST">
                                    <b-form-checkbox 
                                        v-for="option in filterPermission(item2.PJ_ID)" 
                                        :value="option.value">
                                        {{ option.title }}
                                    </b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-td>
                        </b-tr>
                    </template>
                </template>
            </b-table-simple>
            <!--若無次分類時，新增一個主類別名稱的權限設定-->
            <b-table-simple hover small caption-top class="mb-0" v-else>
                <template >
                    <b-tr :key="item.PJ_ID">
                        <!--標頭名稱-->
                        <b-th colspan="2" class="text-left w-50">
                                {{ item.PJ_NAME }}
                        </b-th>
                        <!--功能-->
                        <b-td class="w-50">
                            <b-form-checkbox-group v-model="item.GP_VERIFY_LIST">
                                <b-form-checkbox 
                                    v-for="option in filterPermission(item.PJ_ID)" 
                                    :value="option.value">
                                    {{ option.title }}
                                </b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-td>
                    </b-tr>
                </template>
            </b-table-simple>
        </b-card>
        <!--紀錄區-->
        <b-form-group
            label-size="lg"
            class="p-3 mb-2 bg-secondary text-white mt-3"
            style="opacity: 0.75;"
            v-if="DetailData.creatorName || DetailData.modifierName">
            <b-row v-if="DetailData.creatorName">
                建檔記錄：{{DetailData.creatorName}} ({{ datetimeFormatFloat(DetailData.createDate) }})
            </b-row>
            <b-row v-if="DetailData.modifierName">
                異動紀錄：{{DetailData.modifierName}} ({{ datetimeFormatFloat(DetailData.modifyDate) }})
            </b-row>
        </b-form-group>
        <!--操作功能區-->
        <div>
            <b-button @click="save">儲存</b-button>
        </div>
    </div>
</template>
<script>
import { BIconCurrencyExchange } from 'bootstrap-vue';

export default{
    components:{
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            //樣式編號
            modal:"",
            //群組選項
            groupOptions:[],
            //功能選項
            Permission_Option:[
                {value:1,title:"檢視"},
                {value:2,title:"新增/編輯"},
                {value:4,title:"刪除"},
            ],
            //啟用選項
            statusOptions:[
                {value: null ,text:"請選擇帳號狀態"},
                {value: 0 ,text:"停用"},
                {value: 1 ,text:"啟用"},
            ],
            //詳細資料
            DetailData:{},
            //特殊調整名單
            filterList:[
                {PJ_ID:"PJ20250102",Permission:[1,2]},//日誌檢視
                {PJ_ID:"PJ20250401" ,Permission:[1,2]},//系所簡介
                {PJ_ID:"PJ20250402" ,Permission:[1,2]},//系所位置
                {PJ_ID:"PJ20250601" ,Permission:[1,2]},//大學部招生
                {PJ_ID:"PJ20250602" ,Permission:[1,2]},//碩士生招生
                {PJ_ID:"PJ20250603" ,Permission:[1,2]},//博士生招生
                {PJ_ID:"PJ20250604" ,Permission:[1,2]},//國際生招生
                {PJ_ID:"PJ20250605" ,Permission:[1,2]},//碩專班招生
                {PJ_ID:"PJ20250701" ,Permission:[1,2]},//大學部
                {PJ_ID:"PJ20250702" ,Permission:[1,2]},//碩士生
                {PJ_ID:"PJ20250703" ,Permission:[1,2]},//博士生
                {PJ_ID:"PJ20250704" ,Permission:[1,2]},//碩專生
                {PJ_ID:"PJ20250705" ,Permission:[1,2]},//傳播學程
                {PJ_ID:"PJ2025070501" ,Permission:[1,2]},//宗旨
                {PJ_ID:"PJ2025070502" ,Permission:[1,2]},//課程規則
                {PJ_ID:"PJ2025070503" ,Permission:[1,2]},//辦法
                {PJ_ID:"PJ20250501" ,Permission:[1,2,4]},//專任教授
                {PJ_ID:"PJ20250502" ,Permission:[1,2,4]},//兼任教授
                {PJ_ID:"PJ20250503" ,Permission:[1,2,4]},//退休教授
                {PJ_ID:"PJ20250504" ,Permission:[1,2,4]},//行政人員
                {PJ_ID:"PJ20250505" ,Permission:[1,2]},//合聘教授
                {PJ_ID:"PJ20250506" ,Permission:[1,2,4]},//名譽教授
                {PJ_ID:"PJ20250802" ,Permission:[1,2]},//學術研討會
                {PJ_ID:"PJ20250803" ,Permission:[1,2]},//碩士論文
                {PJ_ID:"PJ20250804" ,Permission:[1,2]},//博士論文
                {PJ_ID:"PJ202509",Permission:[1,2]},//常用表單
                {PJ_ID:"PJ2025110109",Permission:[1,2]},//最新消息
                {PJ_ID:"PJ2025110101",Permission:[1,2]},//系所特色
                {PJ_ID:"PJ2025110102",Permission:[1,2]},//課程亮點
                {PJ_ID:"PJ2025110103",Permission:[1,2]},//招生時程
                {PJ_ID:"PJ2025110104",Permission:[1,2]},//招生交流座談會報名
                {PJ_ID:"PJ2025110105",Permission:[1,2]},//相關影片
                {PJ_ID:"PJ2025110106",Permission:[1,2]},//媒體報導
                {PJ_ID:"PJ2025110107",Permission:[1,2]},//聯絡窗口
                {PJ_ID:"PJ2025110108",Permission:[1,2]},//招生海報與DM圖
                {PJ_ID:"PJ2025110201",Permission:[1,2]},//設立宗旨
                {PJ_ID:"PJ2025110202",Permission:[1,2]},//相關法規
                {PJ_ID:"PJ2025110203",Permission:[1,2]},//課程規劃
                {PJ_ID:"PJ2025110204",Permission:[1,2]},//課程結果
                {PJ_ID:"PJ20251103",Permission:[1,2]},//碩士在職專班論文

            ],
            //群組編號
            id:0,
            //是否更新
            isUpdate:false,

            //API設定區
            apiAccountGroup:(data) => this.userRequest.post("bicd/AccountGroup",data),
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
    },
    methods:{
        //初始化
        init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //樣式編號
            this.modal = this.value.modal;
            //取得目前選擇的群組編號
            this.id = this.$route.query.id;
            //取得所有群組項目
            this.getGroup();

            if(this.id != "0"){
                //取得目前群組所有權限
                this.getGroupInfomation();    
                this.isUpdate = true;         
            }
        },
        //取得所有群組項目
        async getGroup(){
            try{
                //POST 參數
                let jsonReq={
                    TYPE:"GET_GROUP_OPTION",
                    PROJECT_SELECT: {
                        AG_ID: this.id,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Project",jsonReq); 
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.length >0){
                        this.groupOptions = jsonData;
                    }
                }
            }catch(err){
                console.log("ErrFunction: getGroup/n "+err);
            }
        },
        //取得目前群組資訊
        async getGroupInfomation(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE: "SELECT",
                    ACCOUNT_GROUP_SELECT: {
                        AG_ID: this.id,
                    },
                };
                //Token
                let resToken = await this.userRequest.post(
                    "bicd/Token"
                ); 
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post(
                    "bicd/AccountGroup",
                    jsonReq
                );
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status) {
                    let jsonData = JSON.parse(json.Data);
                    this.DetailData = jsonData;
                } 
            }catch(err){
                console.log("ErrFunction: getGroupInfomation/n "+err);
            }
        },
        //儲存
        save() {
            try{
                let json_list = {
                    AG_ID:(this.id != "0")? this.id: null,
                    AG_NAME:this.DetailData.AG_NAME,
                    PERMISSION_LIST: this.groupOptions,
                }

                if(this.isUpdate){
                    //更新修改功能
                    let json = {
                        TYPE:"UPDATE",
                        ACCOUNT_GROUP_UPDATE:json_list,
                    };
                    this.FunctionToken(this.functionUpdate,json);
                }else{
                    //新增修改功能
                    let json = {
                        TYPE:"INSERT",
                        ACCOUNT_GROUP_INSERT:json_list,
                    };
                    this.FunctionToken(this.functionInsert,json);
                }
            }catch(err){
                console.log("ErrFunction: save/n "+err);
            }
        },

       //新增功能
        functionInsert(data){
            this.apiAccountGroup(data)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status){
                        //this.$bvToast.toast("新增成功",{title:"提示",solid:true,});
                        alert("新增成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示                        
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err) =>{
                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //更新功能
        functionUpdate(data){
            this.apiAccountGroup(data)
                .then((res) => {
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        //this.$bvToast.toast("更新成功",{title:"提示",solid:true,});
                        alert("更新成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err)=>{

                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //控制勾選功能
        changeClick(command , item , MainControl){
            switch(command){
                //全選
                case "ALL":
                     if(MainControl){
                        item.GP_VERIFY_LIST=["1","2","4"];
                    }else{
                        item.SubList.forEach(subitme => {
                            //若有子類別
                            if(subitme.SubList != null){
                                subitme.SubList.forEach( thirditem => {
                                    thirditem.GP_VERIFY_LIST=["1","2","4"];
                                });
                            }
                            //無子類別
                            else{
                                subitme.GP_VERIFY_LIST=["1","2","4"];
                            }
                        });
                    }
                    break;
                //取消全選
                case "CANCEL":
                     if(MainControl){
                        item.GP_VERIFY_LIST=[];
                    }else   {
                        item.SubList.forEach(subitme => {
                            //若有子類別
                            if(subitme.SubList != null){
                                subitme.SubList.forEach( thirditem => {
                                    thirditem.GP_VERIFY_LIST=[];
                                });
                            }
                            //無子類別
                            else{
                                subitme.GP_VERIFY_LIST=[];
                            }
                        });
                    }
                    break;
            }
        },
        //篩選特定部分功能
        filterPermission(PJ_ID){
            var filter = this.filterList.filter(x => x.PJ_ID == PJ_ID);
            if(filter.length > 0){
                var Permission = [];
                filter[0].Permission.forEach(x => {
                    var options = this.Permission_Option.filter(option=> option.value == x)[0];
                    Permission.push({value:options.value , title:options.title});
                });
                return Permission;
            }
            else {
                return this.Permission_Option;
            }
        },
        //跳轉至列表頁面
        gotoList(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:2,
                }
            });
        },
    },
}
</script>